import React from 'react';
import PropTypes from 'prop-types';
import OrderPanelSection from '@app/modules/orders/components/OrderPanelSection';
import { FormattedMessage, injectIntl } from 'react-intl';
import OngoingOrdersFilter from '../OngoingOrdersFilter';

const OngoingOrdersSection = ({ intl, filteredOngoingOrders, allOngoingOrders, ...props }) => {
  const labelComponent =
    filteredOngoingOrders.length === allOngoingOrders.length ? (
      <FormattedMessage id="ordersinfo.orders-count" values={{ count: allOngoingOrders.length }} />
    ) : (
      <FormattedMessage
        id="orders.range"
        values={{ total: allOngoingOrders.length, filtered: filteredOngoingOrders.length }}
      />
    );

  return (
    <OrderPanelSection
      {...props}
      orders={filteredOngoingOrders}
      intl={intl}
      filterComponent={<OngoingOrdersFilter label={labelComponent} />}
      sectionName={intl.formatMessage({ id: 'tickets_overview_beingdelivered' })}
      emptyMessage={intl.formatMessage({ id: 'tickets_overview_beingdelivered_empty_message' })}
    />
  );
};

OngoingOrdersSection.propTypes = {
  intl: PropTypes.object.isRequired,
  dealers: PropTypes.object.isRequired,
  filteredOngoingOrders: PropTypes.array.isRequired,
  allOngoingOrders: PropTypes.array.isRequired,
  activeOrder: PropTypes.object,
  offset: PropTypes.number.isRequired,
  userId: PropTypes.string.isRequired,
};

OngoingOrdersSection.defaultProps = {
  activeOrder: null,
};

export default injectIntl(OngoingOrdersSection);



// WEBPACK FOOTER //
// ./src/modules/orders/components/OngoingOrdersSection/OngoingOrdersSection.jsx